export default __webpack_public_path__ + "static/media/environment3.0629a1f1.png";